import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import Loader from "../../Global/Loader";
import { CardBody, Row, Button } from "reactstrap";
// import { Button } from "semantic-ui-react";
import FormCreator from "../../Global/FormBuilder";
import { Forms } from './Components/Forms'
import { ModelMyPerfil } from './Components/Models'
import axios from 'axios';
import iconMyPerfil from '../../../resources/MyProfileIcon.svg'
import { Services } from "../../template/Services";


import Errors from "../Components/Errors";

function MyPerfil({ _user }) {
    const [isLoading, setIsLoading] = useState(false);
    const [model, setModel] = useState(ModelMyPerfil());
    const [isEditing, setIsEditing] = useState(false);
    const [initialData, setInitialData] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [errorState, setErrorState] = useState({
        open: false,
        type: '',
        message: '',
    });


    useEffect(() => {
        getUser()
    }, []);


    const getUser = async () => {
        try {
            const response = await axios.get(`${Services.ADMIN.path}/admin/myPerfil/${_user}`);
            const userData = response.data.data;
            setInitialData(userData);

            setModel((prevModel) => ({
                ...prevModel,
                Nombre: { ...prevModel.Nombre, value: userData.Nombre },
                Apellido: { ...prevModel.Apellido, value: userData.Apellido },
                Email: { ...prevModel.Email, value: userData.Email },
                Rol: { ...prevModel.Rol, value: userData.Rol },
                Posicion: { ...prevModel.Posicion, value: userData.Posicion },
                Telefono: { ...prevModel.Telefono, value: userData.Telefono },
            }));
        } catch (error) {
            console.log("🚀 ~ getUser ~ error:", error)
            throw error;
        } finally {
            setIsLoading(true);
        }
    }

    const validateForm = (model) => {
        let isFormValid = true;

        Object.keys(model).forEach((key) => {
            const field = model[key];
            if (field.required && !field.value) {
                isFormValid = false;
                field.valid = false;
                field.error = "Este campo es requerido";
            }
        });

        return isFormValid;
    };

    const openError = (open, type, message) => {
        setErrorState({ open, type, message });
    };

    const closeError = (open) => {
        setErrorState({ open: open, type: 'error' });
    };

    const handleSave = async () => {
        const isFormValid = validateForm(model);
        if (!isFormValid) {
            setModel({ ...model });
            return;
        }

        try {
            if (model.Password.value) {
                if (!model.confirmPassword.value || model.Password.value !== model.confirmPassword.value) {
                    openError(true, 'error', 'Las contraseñas no coinciden');
                    return;
                }
            }

            setIsSaving(true);
            const dataToSend = {
                name: model.Nombre.value,
                lastName: model.Apellido.value,
                position: model.Posicion.value,
                phone: model.Telefono.value,
                token
            };

            if (model.Password.value) {
                dataToSend.password = model.Password.value;
            }

            const response = await axios.post(`${Services.ADMIN.path}/admin/update_pass/${_user}`, dataToSend);

            if (response.status === 200) {
                openError(true, 'success', 'Usuario actualizado correctamente')
                handleEditClick();
                resetModel();
                await getUser()
            } else {
                openError(true, 'error', '¡Error al actualizar el usuario. Inténtelo de nuevo.!')
            }
        } catch (error) {
            console.log("🚀 ~ handleSave ~ error:", error.response)
            openError(true, 'error', error.response.data.message)

        } finally {
            setIsSaving(false);
        }
    };

    const resetModel = () => {
        setModel(ModelMyPerfil());
    };

    const handleCancel = () => {
        setIsSaving(false);

        handleEditClick();
        resetModel();

        if (initialData) {
            setModel((prevModel) => ({
                ...prevModel,
                Nombre: { ...prevModel.Nombre, value: initialData.Nombre },
                Apellido: { ...prevModel.Apellido, value: initialData.Apellido },
                Email: { ...prevModel.Email, value: initialData.Email },
                Rol: { ...prevModel.Rol, value: initialData.Rol },
                Posicion: { ...prevModel.Posicion, value: initialData.Posicion },
                Telefono: { ...prevModel.Telefono, value: initialData.Telefono },
            }));
        }
    };

    const getFormConfig = (isEditing) => {
        return Forms.myPerfil.map((field) => {
            if (field.type === "header") {
                return field;
            }
            if (!field.editable) {
                return field;
            }
            return {
                ...field,
                type: isEditing ? (field.inputType || 'input') : 'info',
            };
        });
    };

    const handleEditClick = () => {
        setIsEditing((prev) => {
            const newEditingMode = !prev;
            if (newEditingMode) {
                setModel((prevModel) => {
                    const updatedModel = { ...prevModel };
                    Object.keys(updatedModel).forEach((key) => {
                        if (updatedModel[key].hidden) {
                            updatedModel[key].hidden = false; // Mostrar el campo
                        }
                    });
                    return updatedModel;
                });
            } else {
                // Si estamos saliendo del modo de edición, ocultar los campos nuevamente
                setModel((prevModel) => {
                    const updatedModel = { ...prevModel };
                    Object.keys(updatedModel).forEach((key) => {
                        if (updatedModel[key].type === 'password') { // Solo ocultar campos de tipo password
                            updatedModel[key].hidden = true; // Ocultar el campo
                        }
                    });
                    return updatedModel;
                });
            }
            return newEditingMode;
        });
    };

    const validatePassword = (password) => {
        const errors = [];
        if (password.length < 12) {
            errors.push("• Longitud mínima de 12 caracteres");
        }
        if (!/\d/.test(password)) {
            errors.push("• Agregar al menos un número");
        }
        if (!/[A-Z]/.test(password)) {
            errors.push("• Al menos una letra mayúscula");
        }
        if (!/[a-z]/.test(password)) {
            errors.push("• Al menos una letra minúscula");
        }
        if (!/[\W_]/.test(password)) {
            errors.push("• Un carácter especial (*!$%&?)");
        }
        //   const Regex = new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])(?=\S+$).{12,}$/);
        return errors;
    };

    const handleChange = (id, value) => {

        if (value.trim() === '' && value.length > 0) {
            return;
        }

        let valid = true;
        let error = "";

        if (id === 'Password' || id === 'confirmPassword') {
            const errors = validatePassword(value);
            valid = errors.length === 0;
            error = errors.join(", ");


            if (value) {
                setModel((prevModel) => ({
                    ...prevModel,
                    Password: { ...prevModel.Password, required: true },
                    confirmPassword: { ...prevModel.confirmPassword, required: true },
                    [id]: { ...prevModel[id], value, valid, error, required: true },
                }));
            } else {
                const otherFieldValue = id === 'Password' ? model.confirmPassword?.value : model.Password?.value;

                if (!otherFieldValue) {
                    setModel((prevModel) => ({
                        ...prevModel,
                        Password: { ...prevModel.Password, required: false, error: '', valid: true },
                        confirmPassword: { ...prevModel.confirmPassword, required: false, error: '', valid: true },
                        [id]: { ...prevModel[id], value, valid: true, error: '', required: false, },
                    }));
                } else {
                    setModel((prevModel) => ({
                        ...prevModel,
                        [id]: { ...prevModel[id], value, valid, error },
                    }));
                }
            }

            if (id === 'confirmPassword') {
                const passwordValue = model.Password?.value || "";
                if (value !== passwordValue) {
                    valid = false;
                    error = "Las contraseñas no coinciden";
                }
            }
        } else {
            setModel((prevModel) => ({
                ...prevModel,
                [id]: { ...prevModel[id], value, valid, error },
            }));
        }

        if (id === 'Password') {
            const confirmPasswordValue = model.confirmPassword?.value || "";
            if (confirmPasswordValue !== "") {
                const confirmPasswordValid = confirmPasswordValue === value;
                const confirmPasswordError = confirmPasswordValid ? "" : "Las contraseñas no coinciden";

                setModel((prevModel) => ({
                    ...prevModel,
                    confirmPassword: {
                        ...prevModel.confirmPassword,
                        valid: confirmPasswordValid,
                        error: confirmPasswordError,
                    },
                }));
            }
        }
    };


    return (
        <ContentWrapper>
            <Loader hidden={isLoading} />
            <Errors
                open={errorState.open}
                type={errorState.type}
                message={errorState.message}
                setProps={closeError}
            />
            <div className="content-heading">
                <legend className="legendTitle">
                    {/* <i className="far fa-user-circle mr-2 fa-lg"></i> */}
                    <img src={iconMyPerfil} width={'20px'} className="mr-2" />
                    Mi perfil
                </legend>
            </div>
            <div className="myCard">
                <CardBody>
                    <div className='col-12'>
                        <div className="d-flex justify-content-end">
                            <Button color="primary" onClick={handleEditClick} hidden={isEditing} size="sm">Editar</Button>
                            <Button color="danger" onClick={handleCancel} hidden={!isEditing} size="sm" className="mr-2">Cancelar</Button>
                            <Button color="primary" onClick={handleSave} hidden={!isEditing} disabled={isSaving} size="sm">Confirmar</Button>
                        </div>
                        <Row>
                            <FormCreator form={getFormConfig(isEditing)} model={model} onChange={handleChange} />
                        </Row>
                    </div>
                </CardBody>
            </div>
        </ContentWrapper>
    );
}

export default withRouter(MyPerfil);